module.exports = __webpack_public_path__ + "static/media/Fly Monster.05fa5fff.jpg";